module.exports = __webpack_public_path__ + "static/media/dummyPreview.77dba18e.svg";